<template>
  <div id="manifesto">
    <nav-menu v-if="tipo_autenticacao == 'UAD'"/>
    <menu-terceiros v-if="tipo_autenticacao == 'MOT'"/>

    <div class="w3-main" style=" margin-top:43px;">
        <header class="w3-container" style="padding-top:22px">
          <h5>
            <label v-if="manifesto_iniciado" class="w3-text-green w3-right">
              <i class="fa fa-check"></i> Iniciado
            </label>
            <b>
              <i class="fa fa-truck"></i> Manifestos
            </b>
          </h5>
        </header>
        
        <div 
          class="w3-col s12 w3-margin-bottom w3-padding" 
          v-if="logado_usuario_santri == 'S' && !manifesto_selecionado.manifesto_id > 0">
          <input 
            class="w3-check" 
            @change="buscarManifestos()" 
            type="checkbox" 
            id="ckVerTodosManifestos"
            v-model="mostrar_todos_manifestos_aberto" 
            style="cursor: pointer;"/> 
          <label for="ckVerTodosManifestos" style="cursor: pointer;"> Ver todos os manifestos em aberto</label>
        </div>
        
        <div class="w3-row-padding">
          <div 
            class="card-item" 
            :key="manifesto_index"
            v-for="(manifesto, manifesto_index) in manifestos_disponiveis_filtrados"
            v-show="manifesto_selecionado.manifesto_id == undefined && 
            !processando"
            v-cloak>
            
            <div class="w3-container" style="padding:0px 5px 5px 5px">              
              <div class="w3-col s10" @click="buscarManifestoCompleto(manifesto)">
                <label class="texto-vermelho label-clicavel">
                  <strong>Manifesto {{manifesto.manifesto_id}} - {{manifesto.data_cadastro}}</strong>
                </label>
                <p id="assunto" class="texto-preto label-clicavel text-card">{{manifesto.placa_veiculo_id}} - {{manifesto.quantidade_ordens}} {{manifesto.quantidade_ordens > 1 ? 'Ordens' : 'Ordem'}}</p>
                <p 
                  style="color: #31607d " 
                  id="assunto"
                  class="texto-preto label-clicavel text-card" 
                  v-if="manifesto.status == 'I'">
                  <i class="fas fa-road"/> Transporte iniciado
                </p>
                <p 
                  style="color: #7e5a17 " 
                  id="assunto"
                  class="texto-preto label-clicavel text-card" 
                  v-if="manifesto.status == 'T'">
                  <i class="fas fa-road"/> Aguardando início de transporte
                </p>                
                <p 
                  style="color: #3cb371" 
                  id="assunto" 
                  class="texto-preto label-clicavel text-card" 
                  v-if="manifesto.status == 'A'">
                  <i class="fas fa-route"/> Aberto
                </p>
              </div>           
            
              <button
                class="w3-button w3-blue-grey w3-circle w3-right" 
                style="border-radius: 50% !important; height: 35px !important; width: 35px !important; margin-left:-35px; margin-top:15px;"
                v-if="manifesto.status != 'A'"
                v-on:click="voltarStatusManifesto(manifesto.manifesto_id)">
                <i class="fas fa-arrow-left"/>
              </button>
            </div>
          </div>

          <div class="w3-col s12 m12 l12" v-if="processando">
            <div class="w3-panel w3-theme w3-card-2">
              <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
            </div>
          </div>
          
          <div class="w3-col s6" v-if="!processando && !carregando_motorista_inicial && manifestos_disponiveis_filtrados.length == 0">
            <p>Nenhum manifesto disponível.</p>
          </div>
        </div>
        
        <div class="w3-container w3-animate-left" v-if="manifesto_selecionado.manifesto_id != undefined" v-cloak>
          <button 
            id="floating-button"
            title="Recarregar dados"
            v-on:click="voltarPaginaPrincipal()"
            v-if="habilitarVoltarPaginaPrincipal()"
            class="w3-button w3-theme w3-circle w3-display-bottomright" 
            style="border-radius: 50% !important; z-index: 9999">
            <i class="fas fa-arrow-left"></i>
          </button>

          <div class="w3-white w3-block">
            <div class="w3-col" style="display: flex; justify-content: center;">
              <div class="w3-col l4 m6 s12">
                <button 
                  v-if="!manifesto_iniciado" 
                  class="w3-button w3-block w3-mobile w3-theme w3-margin-bottom" 
                  @click="iniciarManifesto">
                  <i class="fa fa-chevron-circle-right"/> Iniciar
                </button>
              </div>
            </div>
            
            <div class="">
              <div 
                class="w3-col s12"
                @click="abrirContentManifesto = !abrirContentManifesto">
                <h4 class="texto-vermelho titulo">
                  <i class="fas fa-route"></i> Manifesto - {{manifesto_selecionado.manifesto_id}} 
                  <span class="w3-right">
                    <i v-if="!abrirContentManifesto" class="fas fa-arrow-right"></i>
                    <i v-else class="fas fa-arrow-down"></i>
                  </span>
                </h4>
              </div>
            </div>
            
            <div class="w3-row" v-cloak v-show="abrirContentManifesto">
              <div class="w3-hide-small w3-row-padding">
                <div class="w3-col s12 l6  w3-margin-top" v-if="manifesto_selecionado.cnpj_empresa">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">CNPJ</label>
                  </div>
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.cnpj_empresa}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.inscricao_estadual_empresa">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Inscrição estadual</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.inscricao_estadual_empresa}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6  w3-margin-top" v-if="manifesto_selecionado.telefones_empresa.length > 0">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Fones</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <button 
                      class="w3-right w3-theme w3-tiny tamanho-43" 
                      @click="modalTelefonesCadastro(manifesto_selecionado.telefones_empresa,
                      manifesto_selecionado.empresa_id, 
                      manifesto_selecionado.nome_empresa)">
                      <i class="fa fa-phone"></i>
                    </button>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.telefone_fax">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Fax</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.telefone_fax}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.manifesto_id">
                  <div class="w3-col s2 line-item">
                    <label class="w3-left titulo-small">Endereço</label>
                  </div>
                  
                  <div class="w3-col s10 line-item">
                    <strong class="w3-right">
                      {{manifesto_selecionado.logradouro_empresa}} {{manifesto_selecionado.complemento_empresa}}, 
                      {{manifesto_selecionado.bairro_empresa}}, 
                      {{manifesto_selecionado.cidade_empresa}} - {{manifesto_selecionado.estado_empresa}}
                    </strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.nome_usuario_insercao">
                  <div class="w3-col s3 line-item">
                    <label class="w3-left titulo-small">Usuário inserção</label>
                  </div>
                  
                  <div class="w3-col s9 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.nome_usuario_insercao}}</strong>
                  </div>
                </div>

                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.frete && manifesto_selecionado.frete !== '0,00'">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Frete</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.frete}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.data_cadastro">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Data cadastro</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.data_cadastro}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.placa_veiculo_id">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Placa do veículo</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.placa_veiculo_id}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.total_peso && manifesto_selecionado.total_peso !== '0,000'">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Total peso</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.total_peso}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.quantidade_clientes">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Qtd. clientes</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.quantidade_clientes}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.quantidade_ordens">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Qtd. ordens</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.quantidade_ordens}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.km_inicial && manifesto_selecionado.km_inicial !== '0'">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Km inicial</label>
                  </div>
                  
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.km_inicial}}</strong>
                  </div>
                </div>
                
                <div class="w3-col s12 l6 w3-margin-top" v-if="manifesto_selecionado.total_produtos">
                  <div class="w3-col s6 m6 line-item">
                    <label class="w3-left titulo-small">Total produtos</label>
                  </div>
                  <div class="w3-col s6 m6 line-item">
                    <strong class="w3-right">{{manifesto_selecionado.total_produtos}}</strong>
                  </div>
                </div>
              </div>
              
              <div class="card-vendas-empresa  w3-hide-large w3-hide-medium">
                <div class="w3-container" style="padding:0px 5px 5px 5px">
                  <div class="w3-col s12">
                    <div class="w3-animate-left">
                      <div class="">
                        <div class="w3-col s12" v-if="manifesto_selecionado.cnpj_empresa">
                          <label>CNPJ: </label>
                          <strong>{{manifesto_selecionado.cnpj_empresa}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.inscricao_estadual_empresa">
                          <label>Inscrição estadual: </label>
                          <strong>{{manifesto_selecionado.inscricao_estadual_empresa}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.telefones_empresa.length > 0">
                          <label>Fones: </label>
                          <button 
                            class="w3-theme w3-tiny tamanho-43"
                            @click="modalTelefonesCadastro(manifesto_selecionado.telefones_empresa, 
                            manifesto_selecionado.empresa_id, 
                            manifesto_selecionado.nome_empresa)">
                            <i class="fa fa-phone"></i>
                          </button>
                        </div> 
                        
                        <div class="w3-col s12">
                          <label>Endereço: </label>
                          <strong>
                            {{manifesto_selecionado.logradouro_empresa}} {{manifesto_selecionado.complemento_empresa}},
                            {{manifesto_selecionado.bairro_empresa}},
                            {{manifesto_selecionado.cidade_empresa}} - {{manifesto_selecionado.estado_empresa}} 
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="w3-col s12" >
                    <div class="w3-animate-left">
                      <div>
                        <div class="w3-col s12">
                          <label>Usuário inserção: </label>
                          <strong>{{manifesto_selecionado.nome_usuario_insercao}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.frete && manifesto_selecionado.frete !== '0,00'">
                          <label>Frete: </label>
                          <strong>{{manifesto_selecionado.frete}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.data_cadastro">
                          <label>Data cadastro: </label>
                          <strong>{{manifesto_selecionado.data_cadastro}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.placa_veiculo_id">
                          <label>Placa do veículo: </label>
                          <strong>{{manifesto_selecionado.placa_veiculo_id}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.total_peso && manifesto_selecionado.total_peso !== '0,000'">
                          <label>Total peso: </label>
                          <strong>{{manifesto_selecionado.total_peso}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.quantidade_clientes">
                          <label>Qtd. clientes: </label>
                          <strong>{{manifesto_selecionado.quantidade_clientes}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.quantidade_ordens">
                          <label>Qtd. ordens: </label>
                          <strong>{{manifesto_selecionado.quantidade_ordens}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.km_inicial && manifesto_selecionado.km_inicial !== '0'">
                          <label>Km inicial: </label>
                          <strong>{{manifesto_selecionado.km_inicial}}</strong>
                        </div>
                        <div class="w3-col s12" v-if="manifesto_selecionado.total_produtos">
                          <label>Total produtos: </label>
                          <strong >{{manifesto_selecionado.total_produtos}}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w3-white w3-block  w3-margin-top">
            <header class="w3-col">
              <h5 class="texto-vermelho titulo"><i class="fas fa-file-invoice"></i> Entregas</h5>
            </header>
            <div class="w3-center">
              <input id="entrega_input" class="w3-check w3-margin-bottom" type="checkbox" v-model="somente_entregas_pendentes"/>
              <label for="entrega_input"><strong>Mostrar somente entregas pendentes</strong></label>
            </div>
            
            <div 
              class="container_entrega" 
              v-for="(cadastro, cadastro_index) in entregasAgrupadas"
              :key="cadastro_index">
              
              <div class="w3-row">
                <h5 class="titulo"><span>{{cadastro.cadastro_id}} - {{cadastro.nome_cliente}}</span>
                </h5>
                <p style="text-align: justify" text>
                  {{cadastro.entregas[0].logradouro_entrega}},
                  {{cadastro.entregas[0].complemento_entrega}}, 
                  {{cadastro.entregas[0].nome_bairro_entrega}}, 
                  {{cadastro.entregas[0].cep}} - {{cadastro.entregas[0].nome_cidade_entrega}} / {{cadastro.entregas[0].estado_entrega_id}} 
                  <br>
                </p>
                <div class="w3-col s12 w3-center">
                  <button 
                    :disabled="!manifesto_iniciado" 
                    class="w3-button w3-deep-orange w3-tiny tamanho-43"
                    @click="modalTelefonesCadastro(cadastro.entregas[0].telefones,
                    cadastro.cadastro_id,
                    cadastro.nome_cliente)">
                    <i class="fa fa-phone"></i>
                  </button>
                  
                  <button
                    :disabled="!manifesto_iniciado" 
                    class="w3-button w3-blue w3-tiny tamanho-43"
                    @click="modalMapaEntrega(cadastro.entregas[0])">
                    <i class="fa fa-map-marked-alt"></i>
                  </button>
                  
                  <button 
                    :disabled="!manifesto_iniciado" 
                    v-if="!cadastro.entregas[0].chegada_informada && controlar_tempo_descarga && habilitarHorarioChegada(cadastro)" 
                    class="w3-button w3-green w3-tiny tamanho-43"
                    @click="modalIniciarEntrega(cadastro.entregas[0])">
                    <i class="fa fa-calendar-check"></i>
                  </button>
                  
                  <button 
                    :disabled="!manifesto_iniciado || !checarEntrega(cadastro)" 
                    v-if="cadastro.entregas[0].chegada_informada && !cadastro.entregas[0].saida_informada" 
                    class="w3-button w3-blue-grey w3-tiny tamanho-43"
                    @click="modalFinalizarEntrega(cadastro.entregas[0])">
                    <i class="fa fa-calendar-minus"></i>
                  </button>
                </div>
                
                <div class="w3-col s12 w3-center texto-vermelho w3-margin-bottom">
                  <strong v-if="cadastro.existe_recebimento_entrega">Possui recebimento na entrega!</strong>
                </div>
                
                <div v-if="controlar_tempo_descarga" class="w3-col s12 m12 l12 w3-center">
                  <label 
                    v-if="cadastro.entregas[0].chegada_informada"
                    class="w3-block w3-green margin-bottom-5">
                    Chegada {{cadastro.entregas[0].data_hora_chegada}}
                  </label>
                </div>
                
                <div v-if="controlar_tempo_descarga" class="w3-col s12 m12 l12 w3-center">
                  <label 
                    v-if="cadastro.entregas[0].saida_informada" 
                    class="w3-block w3-green margin-bottom-5">
                    Saida {{cadastro.entregas[0].data_hora_saida}}
                  </label>
                </div>
              </div>
              <div 
                class="w3-row" 
                v-for="(entrega, entrega_index) in cadastro.entregas" 
                :key="entrega_index" 
                v-cloak>
                
                <div>
                  <div class="w3-container" style="padding:0px 5px 5px 5px">
                    <div class="w3-col s12" @click="verDetalheEntrega(entrega)" style="cursor: pointer;">
                      <div class="w3-left w3-margin-right" style="margin-top: 12px;">
                        <span class="w3-text-green tamanho-140" v-if="entrega.entrega_total"><i class="fa fa-circle"></i></span>
                        <span class="w3-text-indigo tamanho-140" v-if="entrega.entrega_parcial"><i class="fa fa-circle"></i></span>
                        <span class="w3-text-red tamanho-140" v-if="entrega.retorno_total"><i class="fa fa-circle"></i></span>
                      </div>
                      <h6 
                        class="texto-vermelho label-clicavel" 
                        style="text-decoration: underline">
                        <i class="fas fa-clipboard"/>
                        <strong> Entrega {{entrega.entrega_id}} ({{entrega.itens.length}} {{entrega.itens.length > 1 ? 'Produtos' : 'Produto'}})</strong>
                        
                        <div class="w3-col s12 w3-center" v-show="!entrega.visualizar">
                          <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
                        </div> 
                      </h6>
                    </div>
                    
                    <div class="w3-col s12 w3-hide-small w3-margin-bottom" v-show="entrega.visualizar">
                      <div class="w3-col">
                        <h6 class="texto-vermelho titulo">Dados</h6>
                      </div>
                      <div class=" w3-row-padding">
                        <div class="w3-col m6 w3-margin-top" >
                          <div class="w3-col s2 m2 line-item">
                            <label class="w3-left titulo-small">Rota</label>
                          </div>
                          
                          <div class="w3-col s10 line-item">
                            <strong class="w3-right">{{entrega.nome_rota}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="entrega.nome_regiao">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Região</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{entrega.nome_regiao}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="entrega.tipo_imovel_entrega && entrega.tipo_imovel_entrega !== 'Não informado'">
                          <div class="w3-col s5 m5 line-item">
                            <label class="w3-left titulo-small">Tipo imóvel</label>
                          </div>
                          <div class="w3-col s7 m7 line-item">
                            <strong class="w3-right">{{getTipoImovel(entrega.tipo_imovel_entrega)}}</strong> <!-- entrega.tipo_imovel_entrega -->
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="entrega.andar_entrega > 0">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Andar</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{entrega.andar_entrega}}</strong>
                          </div>
                        </div>

                        <div class="w3-col m6 w3-margin-top" v-if="entrega.ponto_referencia_entrega && entrega.ponto_referencia_entrega !== 'Não informado'">
                          <div class="w3-col s5 m5 line-item">
                            <label class="w3-left titulo-small">Ponto referência</label>
                          </div>
                          
                          <div class="w3-col s7 m7 line-item">
                            <strong class="w3-right">{{entrega.ponto_referencia_entrega}}</strong>
                          </div>
                        </div>
                      </div>

                      <div class="w3-col">
                        <h6 class="texto-vermelho titulo">Pedidos</h6>
                      </div>

                      <div v-for="(pedido, key) in entrega.pedido" :key="key" v-cloak class="w3-row-padding">
                        <div class="w3-col m6  w3-margin-top" v-if="pedido.orcamento_id">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Pedido</label>
                          </div>
                          
                          <div class="w3-col s6 line-item">
                            <strong class="w3-right">{{pedido.orcamento_id}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.nome_vendedor">
                          <div class="w3-col s2 m2 line-item">
                            <label class="w3-left titulo-small">Vendedor</label>
                          </div>
                          
                          <div class="w3-col s10 line-item">
                            <strong class="w3-right">{{pedido.nome_vendedor}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.data_recebimento">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Data do pedido</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.data_recebimento}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.nome_usuario_insercao_ent">
                          <div class="w3-col s3 m4 line-item">
                            <label class="w3-left titulo-small">Usuário entrega</label>
                          </div>
                          
                          <div class="w3-col s9 m8 line-item">
                            <strong class="w3-right">{{pedido.nome_usuario_insercao_ent}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6  w3-margin-top" v-if="pedido.pedido_com_prioridade_entrega == 'S'">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Prioritário</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.pedido_com_prioridade_entrega}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.nome_resumido_empresa">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Empresa</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.nome_resumido_empresa}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.peso > 0">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Peso</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{formatarValor(pedido.peso, 2)}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.valor_total_entrega">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Valor produtos</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.valor_total_entrega}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.recebimento_entrega == 'S'">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Recebimento na entrega</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">Sim</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.valor_dinheiro">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Valor dinheiro</label>
                          </div>
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.valor_dinheiro}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.valor_cheque_prazo">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Valor Cheque prazo</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.valor_cheque_prazo}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.valor_cartao_cr">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Valor cartão crédito</label>
                          </div>
                          
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.valor_cartao_cr}}</strong>
                          </div>
                        </div>
                        
                        <div class="w3-col m6 w3-margin-top" v-if="pedido.valor_recebimento_entrega">
                          <div class="w3-col s6 m6 line-item">
                            <label class="w3-left titulo-small">Total recebimento</label>
                          </div>
                          <div class="w3-col s6 m6 line-item">
                            <strong class="w3-right">{{pedido.valor_recebimento_entrega}}</strong>
                          </div>
                        </div>
                      </div>
                      
                      <div class="w3-col s12" v-show="entrega.notas_fiscais.length > 0">
                        <h6 class="texto-vermelho titulo">Notas Fiscais</h6>
                        <p class="w3-row-padding">
                          <a v-for="(nota, key) in entrega.notas_fiscais"
                          :key="key"><span v-if="key>0">
                          / </span>{{formatarValor(nota, 0)}}</a>
                        </p>
                      </div>
                      
                      <div v-if="entrega.observacao_pedido.length" class="w3-col">
                        <h6 class="texto-vermelho titulo">Observações</h6>
                        <div v-for="(observacao, key) in entrega.observacao_pedido"  :key="key" class="w3-row-padding">
                          <p class="texto-preto">{{observacao.observacao_pedido}} {{observacao.observacao_pedido_agendamento}} </p>
                        </div>
                      </div>
                      
                      <div class="w3-animate-left w3-hide-small">
                        <h6 class="texto-vermelho titulo">Itens da entrega</h6>
                        <div class="w3-responsive w3-row-padding">
                          <table class="w3-table-all">
                            <thead>
                              <tr>
                                <th class="tamanho-minimo-200">Produto</th>
                                <th>Marca</th>
                                <th>Lote</th>
                                <th class="alinhamento-numero">Quantidade</th>
                                <th class="alinhamento-numero">Retornada</th>
                                <th>Código de barras</th>
                                <th>Previsão entrega</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, key) in entrega.itens" :key="key" v-cloak>
                                <td>{{item.produto_id}} - {{item.nome}}</td>
                                <td>{{item.marca}}</td>
                                <td>{{item.lote}}</td>
                                <td class="alinhamento-numero">{{item.quantidade}}</td>
                                <td class="alinhamento-numero"><span v-if="item.quantidade_retornada != '0,000'">{{item.quantidade_retornada}}</span></td>
                                <td>{{item.codigo_de_barras}}</td>
                                <td>{{item.previsao_entrega}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    
                    <div class="w3-col s12 w3-hide-large w3-hide-medium" v-show="entrega.visualizar">
                      <div class="w3-col s12">
                        <label>Rota: </label>
                        <strong>{{entrega.nome_rota}}</strong>
                      </div>
                      
                      <div class="w3-col s12" v-if="entrega.nome_regiao">
                        <label>Região: </label>
                        <strong>{{entrega.nome_regiao}}</strong>
                      </div>
                      
                      <div class="w3-col s12" v-if="entrega.tipo_imovel_entrega && entrega.tipo_imovel_entrega !== 'Não informado'">
                        <label>Tipo imóvel: </label>
                        <strong>{{getTipoImovel(entrega.tipo_imovel_entrega)}}</strong>
                      </div>
                      
                      <div class="w3-col s12" v-if="entrega.andar_entrega > 0">
                        <label>Andar: </label>
                        <strong>{{entrega.andar_entrega}}</strong>
                      </div>
                      
                      <div class="w3-col s12" v-if="entrega.ponto_referencia_entrega && entrega.ponto_referencia_entrega !== 'Não informado'">
                        <label>Ponto referência: </label>
                        <strong>{{entrega.ponto_referencia_entrega}}</strong>
                      </div>
                      
                      <div class="w3-col">
                        <h6 class="texto-vermelho titulo">Pedidos</h6>
                      </div>
                      
                      <div v-for="(pedido, pedido_index) in entrega.pedido" :key="pedido_index" v-cloak>
                        <div class="w3-col s12">
                          <label>Pedido: </label>
                          <strong>{{pedido.orcamento_id}}</strong>
                        </div>
                        
                        <div class="w3-col s12">
                          <label>Vendedor: </label>
                          <strong>{{pedido.nome_vendedor}}</strong>
                        </div>
                        
                        <div class="w3-col s12">
                          <label>Data do pedido: </label>
                          <strong>{{pedido.data_recebimento}}</strong>
                        </div>
                        
                        <div class="w3-col s12">
                          <label>Usuário entrega: </label>
                          <strong>{{pedido.nome_usuario_insercao_ent}}</strong>
                        </div>
                        
                        <div class="w3-col s12" v-if="pedido.pedido_com_prioridade_entrega == 'S'">
                          <label>Prioritário: </label>
                          <strong v-if="pedido.pedido_com_prioridade_entrega == 'S'">Sim</strong>
                        </div>
                        
                        <div class="w3-col s12">
                          <label>Empresa: </label>
                          <strong>{{pedido.nome_resumido_empresa}}</strong>
                        </div>
                        
                        <div class="w3-col s12" v-if="pedido.peso > 0">
                          <label>Peso: </label>
                          <strong>{{ formatarValor(pedido.peso, 2) }}</strong>
                        </div>
                        
                        <div class="w3-col s12">
                          <label>Valor produtos: </label>
                          <strong>{{pedido.valor_total_entrega}}</strong>
                        </div>

                        <div v-if="pedido.recebimento_entrega == 'S'" class="texto-vermelho">
                          <div class="w3-col s12">
                            <strong>Recebimento na entrega: </strong>
                            <strong>Sim</strong>
                          </div>
                          
                          <div class="w3-col s12" v-if="pedido.valor_dinheiro != undefined">
                            <strong>Valor dinheiro: </strong>
                            <strong>{{pedido.valor_dinheiro}}</strong>
                          </div>
                          
                          <div class="w3-col s12" v-if="pedido.valor_cheque_vista != undefined">
                            <strong>Valor cheque vista: </strong>
                            <strong>{{pedido.valor_cheque_vista}}</strong>
                          </div>
                          
                          <div class="w3-col s12" v-if="pedido.valor_cheque_prazo != undefined">
                            <strong>Valor Cheque prazo: </strong>
                            <strong>{{pedido.valor_cheque_prazo}}</strong>
                          </div>
                          
                          <div class="w3-col s12" v-if="pedido.valor_cartao_cr != undefined">
                            <strong>Valor cartão crédito: </strong>
                            <strong>{{pedido.valor_cartao_cr}}</strong>
                          </div>
                          
                          <div class="w3-col s12" v-if="pedido.valor_cartao_db != undefined">
                            <strong>Valor cartão débito: </strong>
                            <strong>{{pedido.valor_cartao_db}}</strong>
                          </div>
                          
                          <div class="w3-col s12">
                            <strong>Total recebimento: </strong>
                            <strong>{{pedido.valor_recebimento_entrega}}</strong>
                          </div>
                        </div>
                      </div>

                      <div class="w3-col s12" v-show="entrega.notas_fiscais.length > 0">
                        <h6 class="texto-vermelho titulo">Notas Fiscais</h6>
                        <p><a v-for="(nota, key) in entrega.notas_fiscais" :key="key">
                          <span v-if="key>0"> / </span>{{formatarValor(nota, 0)}}</a>
                        </p>
                      </div>


                      <div v-if="entrega.observacao_pedido.length" class="w3-col">
                        <h6 class="texto-vermelho titulo">Observações</h6>
                        <div v-for="(observacao, key) in entrega.observacao_pedido" :key="key">
                          <p class="texto-preto">{{observacao.observacao_pedido}} {{observacao.observacao_pedido_agendamento}} </p>
                        </div>
                      </div>

                      <div class="w3-animate-left w3-hide-small">
                        <h6 class="texto-vermelho">Itens da entrega</h6>
                        <div class="w3-responsive">
                          <table class="w3-table-all">
                            <thead>
                              <tr>
                                <th class="tamanho-minimo-200">Produto</th>
                                <th>Marca</th>
                                <th>Lote</th>
                                <th class="alinhamento-numero">Quantidade</th>
                                <th class="alinhamento-numero">Retornada</th>
                                <th>Código de barras</th>
                                <th>Previsão entrega</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, item_index) in entrega.itens" :key="item_index" v-cloak>
                                <td>{{item.produto_id}} - {{item.nome}}</td>
                                <td>{{item.marca}}</td>
                                <td>{{item.lote}}</td>
                                <td class="alinhamento-numero">{{item.quantidade}}</td>
                                <td class="alinhamento-numero">{{item.quantidade_retornada}} </td>
                                <td>{{item.codigo_de_barras}}</td>
                                <td>{{item.previsao_entrega}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="w3-col w3-animate-left w3-hide-large w3-hide-medium w3-margin-bottom">
                        <h6 class="texto-vermelho titulo">Itens da entrega</h6>
                        <div class="card-item" v-for="(item, key) in entrega.itens" :key="key" v-cloak>
                          
                          <div class="w3-container">
                            <div class="w3-col s12">
                              <label>Produto: </label>
                              <strong>{{item.produto_id}} - {{item.nome}}</strong>
                            </div>
                            
                            <div class="w3-col s12" v-if="item.marca">
                              <label>Marca: </label>
                              <strong>{{item.marca}}</strong>
                            </div>
                            
                            <div class="w3-col s12" v-if="item.lote && item.lote!== '?'">
                              <label>Lote: </label>
                              <strong>{{item.lote}}</strong>
                            </div>
                            
                            <div class="w3-col s12" v-if="item.quantidade && item.quantidade !== '0,000'">
                              <label>Quantidade: </label>
                              <strong>{{item.quantidade}}</strong>
                            </div>
                            
                            <div class="w3-col s12" v-if="item.quantidade_retornada && item.quantidade_retornada !== '0,000'">
                              <label>Retornada: </label>
                              <strong>{{item.quantidade_retornada}}</strong>
                            </div>
                            
                            <div class="w3-col s12" v-if="item.codigo_de_barras">
                              <label>Código de barras: </label>
                              <strong>{{item.codigo_de_barras}}</strong>
                            </div>
                            
                            <div class="w3-col s12" v-if="item.previsao_entrega">
                              <label>Previsão entrega: </label>
                              <strong>{{item.previsao_entrega}}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div 
                        class="w3-margin-bottom" 
                        v-if="manifesto_selecionado.frase_comprovante_entrega != undefined || 
                        manifesto_selecionado.frase_comprovante_entrega_2 != undefined">
                        
                        <h5 
                          class="w3-center w3-margin-bottom" 
                          v-show="manifesto_selecionado.frase_comprovante_entrega != undefined">
                          {{manifesto_selecionado.frase_comprovante_entrega}}
                        </h5>
                        <h5 
                          class="w3-center w3-margin-bottom" 
                          v-show="manifesto_selecionado.frase_comprovante_entrega_2 != undefined">
                          {{manifesto_selecionado.frase_comprovante_entrega_2}}
                        </h5>
                      </div>
                    </div>
                    
                    <div class="w3-col s12" v-show="entrega.visualizar">
                      <div 
                        v-if="!entregaConfigurada(entrega)"
                        class="w3-col s12 w3-center w3-margin-top w3-margin-bottom align-button-center">
                        <button 
                        class="w3-button w3-theme w3-col l3 m4 w3-mobile" 
                        :disabled="entregaConfigurada(entrega) ||
                        (!entrega.chegada_informada && 
                        controlar_tempo_descarga)"
                        @click="mostrarModalConfigurarEntrega(entrega)">
                        <i class="fa fa-tasks"></i> Configurar entrega
                      </button>
                      </div>
                      <div v-else>
                        <p class="texto-cinza w3-center">Entrega confirmada</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="w3-cotainer">
            <div class="w3-col s12 w3-center w3-margin-bottom" v-if="manifesto_iniciado">
              <button 
                v-if="!manifesto_finalizado &&
                manifesto_iniciado"
                class="w3-button w3-theme"
                @click="finalizarManifesto">
                <i class="fa fa-arrow-alt-circle-down"></i> Finalizar Manifesto
              </button>
              <button v-else class="w3-button w3-green">Manifesto Finalizado</button>
            </div>
          </div>
        </div>

        <!-- Inicio modal para informar hora de chegada -->
        <div 
          id="modalInformarHoraChegada" 
          class="w3-modal" 
          v-if="abrirModalInformarHoraChegada" 
          @click="abrirModalInformarHoraChegada = false" 
          style="display: block">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalInformarHoraChegada = false" class="w3-button w3-display-topright">&times;</span>
              <h5 class="texto-vermelho titulo">Informar hora de chegada</h5>
            </header>
            <div class="w3-row-padding">
              <div class="w3-col s12 m12 l5">
                <label>Data de chegada</label>
                <input type="date" class="w3-input w3-border" v-model="data_chegada"/>
              </div>
              <div class="w3-col s12 m12 l5">
                <label>Hora de chegada</label>
                <input type="time" class="w3-input w3-border" v-model="hora_chegada"/>
              </div>
              <div class="w3-col s12 m12 l2 w3-center w3-margin-bottom">
                <br>
                <button class="w3-button w3-theme" @click="iniciarEntrega"><span>Confirmar</span></button>
              </div>
            </div><br>
          </div>
        </div>
        <!-- Fim modal para informar hora de chegada -->

        <!-- Inicio modal para informar hora de saida -->
        <div
          id="modalInformarHoraSaida" 
          class="w3-modal" 
          v-if="abrirModalInformarHoraSaida"
          @click="abrirModalInformarHoraSaida = false" 
          style="display: block">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalInformarHoraSaida = false" class="w3-button w3-display-topright">&times;</span>
              <h5 class="texto-vermelho titulo">Informar hora de saida</h5>
            </header>
            <div class="w3-row-padding">
              <div class="w3-col s12 m12 l5">
                <label>Data e hora saida</label>
                <input type="date" class="w3-input w3-border" v-model="data_saida"/>
              </div>
              <div class="w3-col s12 m12 l5">
                <label>Hora de saída</label>
                <input type="time" class="w3-input w3-border" v-model="hora_saida"/>
              </div>
              <div class="w3-col s12 m12 l2 w3-center w3-margin-bottom">
                <br>
                <button class="w3-button w3-theme" @click="finalizarEntrega"><span>Confirmar</span></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Fim modal para informar hora de saida -->

        <!-- Inicio modal para abrir mapa -->
        <div 
          id="modalAbrirMapaEntrega"
          class="w3-modal" 
          v-if="abrirModalAbrirMapaEntrega"
          @click="abrirModalAbrirMapaEntrega = false" 
          style="display: block">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span  @click="abrirModalAbrirMapaEntrega = false" class="w3-button w3-display-topright">&times;</span>
              <h5 class="texto-vermelho titulo"><i class="fas fa-map"></i> Tipo de pesquisa</h5>
            </header>
            <div class="w3-row-padding">
              <div class="w3-col s12 m12 l12">
                <div class="w3-col s12 m12 l12 w3-margin-bottom">
                  <select class="w3-select w3-border" v-model="tipo_pesquisa_mapa">
                    <option value="CEP">CEP</option>
                    <option value="ENT">Endereço de entrega</option>
                    <option value="NRS">Nome\Razão social</option>
                  </select>
                </div>
                <div class="w3-col s12 m12 l12 w3-margin-bottom">
                  <button class="w3-block w3-button w3-theme" @click="abrirMapaEndereco()"><span>Ir para o mapa</span></button>
                </div>
              </div>
            </div><br>
          </div>
        </div>
        <!-- Fim modal para abrir mapa -->

        <div id="modalEnviandoFotos" class="w3-modal" v-if="processando_fotos" style="display: block">
          <div class="w3-col s12 m12 l12" v-if="processando_fotos">
            <div class="w3-panel w3-theme w3-card-2">
              <p><i class="fa fa-sync-alt w3-spin"></i> {{ descricao_processando_fotos}}</p>
            </div>
          </div>
        </div>

        <!-- Inicio modal configurar entrega -->
        <div 
          id="modalConfigurarEntrega" 
          class="w3-modal" 
          v-if="abrirModalConfigurarEntrega"
          @click="abrirModalConfigurarEntrega = false" 
          style="display: block">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span
                @click="abrirModalConfigurarEntrega = false"
                class="w3-button w3-display-topright">&times;</span>
              
              <h4 class="texto-vermelho titulo">
                <span>Configurar Entrega - {{entrega_configurando.entrega_id}}</span>
              </h4>
            </header>
            <div class="w3-row-padding" v-if="entrega_configurando.pedido">
              <div class="w3-col s12 m12 l12">
                <div class="w3-col w3-margin-top w3-row-padding">
                  <div  class="w3-col l4 w3-margin-bottom">
                    <button
                      class="botao-tipo-entrega"
                      @click="configurarTipoEntrega('ET')"
                      id="ET">
                      <span>Entrega total</span>
                    </button>
                  </div>
                  
                  <div class="w3-col l4 w3-margin-bottom">
                    <button
                      class="botao-tipo-entrega"
                      @click="configurarTipoEntrega('EP')"
                      id="EP">
                      <span>Entrega parcial</span>
                    </button>
                  </div>
                  
                  <div class="w3-col l4 w3-margin-bottom">
                    <button
                      class="botao-tipo-entrega"
                      @click="configurarTipoEntrega('RT')"
                      id="RT">
                      <span>Retorno total</span>
                    </button>
                  </div>
                </div>
              </div>
              
              <div class="w3-col s12 m12 l12" v-show="abrirContentConfigurarEntrega">
                <div class="w3-col w3-hide-small" v-if="entrega_configurando.tipo_entrega !== 'RT'">
                  <h5 class="texto-vermelho">Pessoa que recebeu</h5>
                  <label>Nome</label>
                  <table>
                    <tr>
                      <th style="width: 100%"><input type="text" class="w3-input w3-border" v-model="entrega_configurando.nome_pessoa_recebeu"/></th>
                      <th><button class="w3-button w3-theme" @click="abrirModalAssinatura">Assinatura</button></th>
                    </tr>
                  </table>
                </div>
                
                <div class="w3-hide-medium w3-hide-large" v-if="entrega_configurando.tipo_entrega !== 'RT'">
                  <div class="w3-col" >
                    <h5 class="texto-vermelho">Pessoa que recebeu</h5>
                    <label>Nome</label>
                    <input type="text" class="w3-input w3-border" v-model="entrega_configurando.nome_pessoa_recebeu"/>
                  </div>
                  
                  <div class="w3-col w3-margin-top">
                    <button class="w3-button w3-block w3-theme" @click="abrirModalAssinatura">Assinatura</button>
                  </div>
                </div>
                
                <div v-if="entrega_configurando.tipo_entrega !== 'RT' && this.assinatura_definida">
                  <label>Assinatura coletada</label>
                  <div>
                    <img id="img_assinatura" class="assinatura" :src="assinatura_definida"/>
                  </div>
                </div>
                
                <div class="w3-col" v-if="entrega_configurando.tipo_entrega !== 'ET'">
                  <h5 class="texto-vermelho">Motivo do retorno</h5>
                  <label>Motivo</label>
                  <select class="w3-select w3-border" v-model="entrega_configurando.motivo_retorno">
                    <option 
                      :value="motivo.motivo_retorno_id"
                      v-for="(motivo, motivo_index) in motivos_retornos" 
                      :key="motivo_index">{{motivo.nome}}
                    </option>
                  </select> <br>
                  <label>Observação do retorno</label>
                  <textarea 
                    rows="10" 
                    class="w3-input w3-border" 
                    v-model="entrega_configurando.observacao_retorno">
                  </textarea>
                  <br>
                  <label>Observação nota</label>
                  <input class="w3-input w3-border" v-model="entrega_configurando.observacao_nota"/>
                </div>
                
                <div class="w3-col w3-margin-bottom" v-if="entrega_configurando.tipo_entrega === 'EP'">
                  <h5 class="texto-vermelho">Itens da entrega</h5>
                  <div class="w3-responsive w3-hide-small">
                    <table class="w3-table-all">
                      <thead>
                        <tr>
                          <th class="tamanho-minimo-200">Produto</th>
                          <th class="alinhamento-numero">Quantidade</th>
                          <th class="alinhamento-numero">Retornada</th>
                          <th>Marca</th>
                          <th>Lote</th>
                          <th>Código de barras</th>
                          <th>Previsão entrega</th>
                          <th class="alinhamento-numero">Pedido</th>
                          <th class="alinhamento-numero">Entrega</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, item_index) in entrega_configurando.itens" :key="item_index" v-cloak >
                          <td>{{item.produto_id}} - {{item.nome}}</td>
                          <td class="alinhamento-numero">{{item.quantidade}}</td>
                          <td>
                            <input 
                              style="min-width: 100px"
                              class="w3-input w3-border"
                              name="quantidade_retornada"
                              v-bind:precision="3" separator="." 
                              v-model="item.quantidade_retornada"/>
                            
                          </td>
                          <td>{{item.marca}}</td>
                          <td>{{item.lote}}</td>
                          <td>{{item.codigo_de_barras}}</td>
                          <td>{{item.previsao_entrega}}</td>
                          <td class="alinhamento-numero">{{item.orcamento_id}}</td>
                          <td class="alinhamento-numero">{{item.entrega_id}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="w3-hide-medium w3-hide-large">
                    <div 
                      class="w3-col"
                      v-for="(item, key) in entrega_configurando.itens"
                      v-cloak 
                      :key="key">
                      
                      <p v-if="key != 0" style="color: rgb(156, 29, 28); text-align: center;"><i class="fas fa-ellipsis-h"></i></p>
                      <div class="w3-col s12">
                        <label>Produto: </label>
                        <strong>{{item.produto_id}} - {{item.nome}}</strong>
                      </div>
                      
                      <div class="w3-col s12">
                        <label>Quantidade: </label>
                        <strong>{{item.quantidade}}</strong>
                      </div>
                      
                      <div class="w3-col s12">
                        <div class="w3-col s3" style="margin-top: 7px;">
                          <label>Retornada: </label>
                        </div>
                        
                        <div class="w3-col s9">
                          <input
                            style="min-width: 100px"
                            class="w3-input w3-border"
                            name="quantidade_retornada"
                            v-bind:precision="3"
                            separator="." 
                            v-model="item.quantidade_retornada"/>
                        
                        </div>
                      </div>
                      
                      <div class="w3-col s12">
                        <label>Marca: </label>
                        <strong>{{item.marca}}</strong>
                      </div>
                      
                      <div class="w3-col s12" v-if="item.lote != '?'">
                        <label>Lote: </label>
                        <strong>{{item.lote}}</strong>
                      </div>
                      
                      <div class="w3-col s12" v-if="item.codigo_de_barras">
                        <label>Código de barras: </label>
                        <strong>{{item.codigo_de_barras}}</strong>
                      </div>
                      
                      <div class="w3-col s12">
                        <label>Previsão entrega: </label>
                        <strong>{{item.previsao_entrega}}</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w3-center" v-if="existeRecebimentoEntrega(entrega_configurando)">
                  <input 
                    class="w3-check w3-margin-bottom" 
                    type="checkbox" 
                    v-model="entrega_configurando.ciente_recebimento_entrega"/>
                    
                  <label>Estou ciente de que esta entrega é de um pedido com recebimento na entrega</label>
                </div>

                <div class="w3-responsive w3-col">
                  <input
                    type="file"
                    id="ifotos"
                    accept=".jpg"
                    class="fotos"
                    value=""
                    v-on:change="lerArquivo()"
                  />
                  <div class="imagemCentralizada w3-center">
                    <div class="w3-col s12 m4">
                      <div class="w3-margin">
                        <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                        <span @click="limparFoto(0)" class="w3-button w3-display-topright">&times;</span>
                        </header>
                        <img id="img01" class="imagem" @click="adicionarFoto('1')" :src="fotoPadrao"/>
                      </div>
                    </div>

                    <div class="w3-col s12 m4">
                      <div class="w3-margin">
                        <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                          <span @click="limparFoto(1)" class="w3-button w3-display-topright">&times;</span>
                        </header>
                        <img id="img02" class="imagem" @click="adicionarFoto('2')" :src="fotoPadrao"/>
                      </div>
                    </div>

                    <div class="w3-col s12 m4">
                      <div class="w3-margin">
                        <header class="w3-container w3-col foto-cabecalho" style="position:relative;">
                        <span @click="limparFoto(2)" class="w3-button w3-display-topright">&times;</span>
                        </header>
                        <img id="img03" class="imagem" @click="adicionarFoto('3')" :src="fotoPadrao"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w3-col s12 m12 l12 w3-margin-bottom w3-margin-top">
                  <button 
                    class="w3-block w3-button w3-theme"
                    :disabled="(existeRecebimentoEntrega(entrega_configurando) && 
                    !entrega_configurando.ciente_recebimento_entrega) &&
                    entrega_configurando.tipo_entrega != ''" 
                    @click="configurarEntrega(entrega_configurando)">
                    <i class="fas fa-check-circle"/> Confirmar
                  </button>
                </div>
              </div>
            </div><br>
          </div>
        </div>
        <!-- Fim modal configurar entrega -->

        <!-- Inicio modal de quantidade de retorno de produto (Retorno parcial)-->
        <div 
          id="modalTelefonesCadastro" 
          class="w3-modal" 
          v-if="abrirModalTelefonesCadastro &&
          telefones_modal.length > 0"
          @click="abrirModalTelefonesCadastro = false"
          style="display: block">
          
          <div class="w3-modal-content w3-animate-zoom" @click.stop>
            <header class="w3-container">
              <span @click="abrirModalTelefonesCadastro = false" class="w3-button w3-display-topright">&times;</span>
              <h4 class="texto-vermelho titulo">
                <i class="fas fa-phone"></i> {{cadastro_configurando.cadastro_id}} - {{cadastro_configurando.nome}}
              </h4>
            </header>
            
            <div class="w3-container" v-cloak>
              <div class="w3-responsive">
                <table class="w3-table-all">
                  <thead>
                    <tr>
                      <th>Telefone</th>
                      <th>Tipo do telefone</th>                      
                      <th>Observação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(telefone, telefone_index) in telefones_modal" :key="telefone_index">
                      <td><a :href="`tel:${telefone.telefone}`">{{telefone.telefone}}</a></td>
                      <td>{{telefone.tipo_telefone}}</td>                      
                      <td>{{telefone.observacao}}</td>
                    </tr>                    
                  </tbody>
                </table>
              </div>
            </div><br>
          </div>
        </div>
        <!-- Fim modal de quantidade de retorno de produto -->

        <!-- Inicio modal de assinatura  -->
        <modal-assinatura
          v-if="mostrarModalAssinatura"
          @close="mostrarModalAssinatura = false"
          @carregarImagem="carregarAssinatura"
        ></modal-assinatura>
        <!-- Fim modal de assinatura  -->
      </div>

      <button 
        id="floating-button" 
        title="Buscar manifestos" 
        v-on:click="buscarManifestos()"
        v-if="habilitarBuscarManifestos()"
        style="border-radius: 50% !important"
        class="w3-button w3-theme w3-circle w3-display-bottomright">
        <i class="fa fa-sync-alt"></i>
      </button>

    </div>
</template>

<script>
  import moment from 'moment';
  import VueNumeric from 'vue-numeric';
  import store from '@/ambiente/store';
  import NavMenu from '@/components/Menu'
  import RSessao from '@/components/Rest/RSessao';
  import MenuTerceiros from "@/components/MenuTerceiros";
  import RManifesto from '@/components/Rest/RManifesto.js';
  import ModalAssinatura from '@/components/ModalAssinatura2';
  import RFotoEntrega from '@/components/Rest/RFotoEntrega.js';
  import Biblioteca from '@/components/Repositorio/Biblioteca';

  export default {
    name: 'Manifestos',
    
    components: {
      NavMenu,
      VueNumeric,
      MenuTerceiros,
      ModalAssinatura
    },

    data() {
      return {
        api: process.env.API,
        processando: true,
        descricao_processando_fotos: '',
        processando_fotos: false,
        /* Usuário */
        cadastro_id_logado: '',
        tipo_autenticacao: '',
        logado_usuario_santri: 'N',
        /* Assinatura */
        mostrarModalAssinatura: false,
        assinatura_definida: '',
        /* Motorista */
        indice_motorista_pesquisa: '',
        chave_motorista_pesquisa: '',
        motoristas_disponiveis_filtrados: [],
        motorista_selecionado: {},
        carregando_motorista_inicial: false,
        carregou_motorista_inicial: false,
        motorista_logado_manifesto: false,
        /* Dados de pesquisa */
        codigo_manifesto: '',
        /* Manifestos */
        manifestos_disponiveis_filtrados: [],
        manifesto_selecionado: {},
        mostrar_detalhes_manifesto: false,
        mostrar_detalhes_entregas: false,
        manifesto_iniciado: false,
        manifesto_finalizado: false,
        iniciar_manifesto: false,
        finalizar_manifesto: false,
        controlar_tempo_descarga: false,
        mostrar_todos_manifestos_aberto: false,
        /* Entrega */
        informar_chegada: false,
        informar_saida: false,
        confirmar_entrega_total: false,
        confirmar_entrega_parcial: false,
        confirmar_retorno_total: false,
        data_chegada: '',
        hora_chegada: '',
        data_saida: '',
        hora_saida: '',
        cliente_id_entrega: '',
        entrega_id_selecionada: '',
        grupo_endereco_id_selecionado: 0,
        somente_entregas_pendentes: true,
        /* Entrega parcial */
        produto_entrega_parcial: {},
        /* Mapa */
        tipo_pesquisa_mapa: '',

        entrega_configurando: {},
        cadastro_configurando: {},

        nome_pessoa_recebeu_web: '',
        motivo_retorno: '',
        observacao_retorno: '',
        observacao_nota: '',
        motivos_retornos: [],
        fotos: [
          {base64: undefined},
          {base64: undefined},
          {base64: undefined}
        ],
        fotoPadrao: "/static/imagens/ImagemAdicionar.png",
        imagemSelecionada: undefined,

        controlSwalModalStatus: false,
        abrirContentManifesto: false,
        abrirContentConfigurarEntrega: false,
        abrirModalInformarHoraChegada: false,
        abrirModalInformarHoraSaida: false,
        abrirModalAbrirMapaEntrega: false,
        abrirModalConfigurarEntrega: false,
        abrirModalTelefonesCadastro: false,
        
        telefones_modal: []
      }
    },
    computed: {
      entregasAgrupadas: function(){
        var agrupadas = [];
        var cliente_anterior = 0;
        var grupo_endereco_anterior = 0;

        for (var i = 0; i < this.manifesto_selecionado.entregas.length; i++){
          if (agrupadas == []){
            let entrega = {};
            entrega.cadastro_id = this.manifesto_selecionado.entregas[i].cadastro_id;
            entrega.nome_cliente = this.manifesto_selecionado.entregas[i].nome_cliente;
            entrega.grupo_endereco_id = this.manifesto_selecionado.entregas[i].grupo_endereco_id;
            entrega.existe_entrega_pendente =
              (
                !this.manifesto_selecionado.entregas[i].entrega_total &&
                !this.manifesto_selecionado.entregas[i].retorno_total &&
                !this.manifesto_selecionado.entregas[i].entrega_parcial
              ) ||
              (this.controlar_tempo_descarga && !this.manifesto_selecionado.entregas[i].saida_informada);

            entrega.existe_recebimento_entrega = this.existeRecebimentoEntrega(this.manifesto_selecionado.entregas[i])

            entrega.entregas = [];
            entrega.entregas.push(this.manifesto_selecionado.entregas[i]);

            agrupadas.push(entrega);
            cliente_anterior = entrega.cadastro_id;
            grupo_endereco_anterior = entrega.grupo_endereco_id;
          }
          else {
            if
              (
                (cliente_anterior != this.manifesto_selecionado.entregas[i].cadastro_id) ||
                (grupo_endereco_anterior != this.manifesto_selecionado.entregas[i].grupo_endereco_id)
              )
            {
              
              let entrega = {};
              entrega.cadastro_id = this.manifesto_selecionado.entregas[i].cadastro_id;
              entrega.nome_cliente = this.manifesto_selecionado.entregas[i].nome_cliente;
              entrega.grupo_endereco_id = this.manifesto_selecionado.entregas[i].grupo_endereco_id;              
                entrega.existe_entrega_pendente =
                (
                  !this.manifesto_selecionado.entregas[i].entrega_total &&
                  !this.manifesto_selecionado.entregas[i].retorno_total &&
                  !this.manifesto_selecionado.entregas[i].entrega_parcial
                ) ||
                (this.controlar_tempo_descarga && !this.manifesto_selecionado.entregas[i].saida_informada);

              entrega.existe_recebimento_entrega = this.existeRecebimentoEntrega(this.manifesto_selecionado.entregas[i])

              entrega.entregas = [];
              entrega.entregas.push(this.manifesto_selecionado.entregas[i]);

              agrupadas.push(entrega);
              cliente_anterior = entrega.cadastro_id;
              grupo_endereco_anterior = entrega.grupo_endereco_id;
            }
            else{
              agrupadas[agrupadas.length -1].existe_recebimento_entrega = agrupadas[agrupadas.length -1].existe_recebimento_entrega || this.existeRecebimentoEntrega(this.manifesto_selecionado.entregas[i]);
              agrupadas[agrupadas.length -1].existe_entrega_pendente =
                (agrupadas[agrupadas.length -1].existe_entrega_pendente) ||
                (
                  !this.manifesto_selecionado.entregas[i].entrega_total &&
                  !this.manifesto_selecionado.entregas[i].retorno_total &&
                  !this.manifesto_selecionado.entregas[i].entrega_parcial
                ) ||
                (this.controlar_tempo_descarga && !this.manifesto_selecionado.entregas[i].saida_informada);

              agrupadas[agrupadas.length -1].entregas.push(this.manifesto_selecionado.entregas[i]);
            }
          }
        }

        agrupadas = agrupadas.filter((entrega) => this.somente_entregas_pendentes ? entrega.existe_entrega_pendente === true : true);
        return agrupadas;
      },
      verificarModal() {
        if (this.abrirModalInformarHoraChegada || this.abrirModalInformarHoraSaida ||
            this.abrirModalAbrirMapaEntrega || this.abrirModalConfigurarEntrega ||
            this.abrirModalTelefonesCadastro ) return true
        else return false
      },
    },
    watch: {
      abrirModalInformarHoraChegada() {
        this.verificarModalAberto()
      },
      abrirModalInformarHoraSaida() {
        this.verificarModalAberto()
      },
      abrirModalAbrirMapaEntrega() {
        this.verificarModalAberto()
      },
      abrirModalConfigurarEntrega() {
        this.verificarModalAberto()
      },
      abrirModalTelefonesCadastro() {
        this.verificarModalAberto()
      },
    },
    methods: {
      verificarModalAberto(){
        const el = document.documentElement
        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        }
      },

      fecharModalConfigurarEntregas() {
        this.abrirContentConfigurarEntrega = false
        this.addClassButtonEntrega("ET", "EP", "RT", true)
        this.abrirModalConfigurarEntrega = false
      },

      getTipoImovel(tipo) {
        switch (tipo) {
          case 'NIN':
            return "Não informado"
            break;
          case 'APH':
            return "Apart Hotel"
            break;
          case 'APA':
            return "Apartamento"
            break;
          case 'CCO':
            return "Casa comercial"
            break;
          case 'CAC':
            return "Casa em condomínio"
            break;
          case 'CAS':
            return "Casa"
            break;
          case 'FAZ':
            return "Fazenda/chácara/sítio"
            break;
          case 'GAL':
            return "Galpão"
            break;
          case 'LOJ':
            return "Loja"
            break;
          case 'LOT':
            return "Lote"
            break;
          case 'PRE':
            return "Prédio"
            break;
          case 'QUI':
            return "Quitinete"
            break;
          case 'SAL':
            return "Sala comercial"
            break;
          case 'SOB':
            return "Sobrado"
            break;
          default:
            return tipo;
        }
      },

      configurarTipoEntrega(tipo) {
        this.abrirContentConfigurarEntrega = true

        switch (tipo) {
          case 'ET':
            this.entrega_configurando.tipo_entrega = "ET"
            this.addClassButtonEntrega("ET", "EP", "RT")
            break;
          case 'EP':
            this.entrega_configurando.tipo_entrega = "EP"
            this.addClassButtonEntrega("EP", "RT", "ET")
            break;
          case 'RT':
            this.entrega_configurando.tipo_entrega = "RT"
            this.addClassButtonEntrega("RT", "EP", "ET")
            break;
        }
      },

      addClassButtonEntrega(addClass, removeClassOne, removeClassTwo, closeModal = false) {
        var one = document.getElementById(addClass);
        var two = document.getElementById(removeClassOne);
        var three = document.getElementById(removeClassTwo);

        if (!closeModal) {
          one.classList.toggle("botao-tipo-entrega-selecionado");
        } else {
          one.classList.remove("botao-tipo-entrega-selecionado");
        }

        two.classList.remove("botao-tipo-entrega-selecionado");
        three.classList.remove("botao-tipo-entrega-selecionado");
      },

      carregarAssinatura(assinatura) {
        this.assinatura_definida = assinatura;
      },

      setChaveMotoristaPesquisa: function(indice) {
        this.indice_motorista_pesquisa = indice;
      },

      getIconeFiltroMotorista: function(indice) {
        if(indice === this.indice_motorista_pesquisa) {
          return 'fa fa-check-square-o icone-vermelho';
        }
        else {
          return 'fa fa-square-o'
        }
      },

      verDetalheEntrega: function(entrega){
        if (!this.manifesto_iniciado){
          Biblioteca.exclamar("Para visualizar os detalhes da entrega, e necessário iniciar o manifesto!");
          return;
        }

        for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
          if (this.manifesto_selecionado.entregas[i].entrega_id == entrega.entrega_id)
            this.manifesto_selecionado.entregas[i].visualizar = !this.manifesto_selecionado.entregas[i].visualizar;
        }
      },

      abrirMapaEndereco: function(){
        for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
          if (this.manifesto_selecionado.entregas[i].entrega_id == this.entrega_id_selecionada){
            if (this.tipo_pesquisa_mapa == 'ENT')
              window.open(
                "https://www.google.com/maps/search/?api=1&query=" +
                this.manifesto_selecionado.entregas[i].logradouro_entrega +
                "+" +
                this.manifesto_selecionado.entregas[i].nome_bairro_entrega +
                "+" +
                this.manifesto_selecionado.entregas[i].nome_cidade_entrega,'_blank'
              );

            if (this.tipo_pesquisa_mapa == 'CEP')
              window.open("https://www.google.com/maps/search/?api=1&query=" + this.manifesto_selecionado.entregas[i].cep,'_blank');

            if (this.tipo_pesquisa_mapa == 'NRS')
              window.open("https://www.google.com/maps/search/?api=1&query=" + this.manifesto_selecionado.entregas[i].nome_cliente,'_blank');
          }
        }
      },

      modalMapaEntrega: function(entrega){
        this.entrega_id_selecionada = entrega.entrega_id;
        this.grupo_endereco_id_selecionado = entrega.grupo_endereco_id;
        this.abrirModalAbrirMapaEntrega = true
      },

      habilitarHorarioChegada(cadastro){
        let habilitar = true;

        for (let i = 0; i < this.entregasAgrupadas.length; i++) {

          for (let j = 0; j < this.entregasAgrupadas[i].entregas.length; j++) {
            if 
              (
                (cadastro.cadastro_id != this.entregasAgrupadas[i].cadastro_id) &&
                (this.entregasAgrupadas[i].entregas[j].chegada_informada && !this.entregasAgrupadas[i].entregas[j].saida_informada)
              )
            {
              habilitar = false;
              break;    
            }
          }

          if (!habilitar){
            break;
          }
        }

        return habilitar;
      },

      modalIniciarEntrega: function(entrega){
        if (this.verificarMotoristaLogado()){
          return;
        }

        this.entrega_id_selecionada = entrega.entrega_id;
        this.grupo_endereco_id_selecionado = entrega.grupo_endereco_id;
        this.cliente_id_entrega = entrega.cadastro_id;

        this.data_chegada = moment(new Date(), 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD');
        this.hora_chegada = moment(new Date(), 'DD/MM/YYYY HH:mm').format('HH:mm');

        this.abrirModalInformarHoraChegada = true;
      },

      async modalFinalizarEntrega(entrega){
        for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
          if
            (
              (this.manifesto_selecionado.entregas[i].cadastro_id == entrega.cadastro_id) &&
              (this.manifesto_selecionado.entregas[i].grupo_endereco_id == entrega.grupo_endereco_id)
            )
          {
            if (
              !this.manifesto_selecionado.entregas[i].entrega_parcial &&
              !this.manifesto_selecionado.entregas[i].entrega_total &&
              !this.manifesto_selecionado.entregas[i].retorno_total
            ){
              await swal(
                "Para informar o horário de saída é necessário configurar a entrega " + this.manifesto_selecionado.entregas[i].entrega_id + ". " +
                'Deseja configurar a entrega agora?', 
                {
                  buttons: {
                    nao: "Não",
                    sim: "Sim"
                  },
                }
              )
              .then(async (opcao) => {
                if (opcao == 'sim') {
                  await this.mostrarModalConfigurarEntrega(this.manifesto_selecionado.entregas[i]);
                }
              });
              return;
            }
          }
        }

        // Enviar a data de chegada para que posssa realizar validações no servidor
        this.entrega_id_selecionada = entrega.entrega_id;
        this.grupo_endereco_id_selecionado = entrega.grupo_endereco_id;
        this.cliente_id_entrega = entrega.cadastro_id;

        this.data_saida = moment().format('YYYY-MM-DD');
        this.hora_saida = moment(new Date(), 'DD/MM/YYYY HH:mm').format('HH:mm');

        this.abrirModalInformarHoraSaida = true;
      },

      abrirModalAssinatura: function(){
        this.mostrarModalAssinatura = true;
      },
      
      async configurarEntrega(entrega){
        entrega.entrega_total = false;
        entrega.retorno_total = false;
        this.cliente_id_entrega = entrega.cadastro_id;
        this.entrega_id_selecionada = entrega.entrega_id;
        this.grupo_endereco_id_selecionado = entrega.grupo_endereco_id;

        this.confirmar_entrega_parcial = entrega.tipo_entrega == 'EP';
        this.confirmar_entrega_total = entrega.tipo_entrega == 'ET';
        this.confirmar_retorno_total = entrega.tipo_entrega == 'RT';
        this.motivo_retorno = entrega.motivo_retorno;
        this.observacao_retorno = entrega.observacao_retorno;
        this.observacao_nota = entrega.observacao_nota;
        this.nome_pessoa_recebeu_web = entrega.nome_pessoa_recebeu;

        let retorno_verificacao = await this.buscarProdutosEntregaVerificacao();
        if(!retorno_verificacao){
          return;
        }

        let produtos_entrega = retorno_verificacao.produtos_entrega;

        if (this.confirmar_entrega_parcial) {
          if (retorno_verificacao.qtd_quantidade_retornada <= 0) {
            Biblioteca.exclamar("É necessário informar alguma quantidade de retorno!");
            return;
          }
        }

        await this.atualizarManifesto();
      },

      buscarProdutosEntregaVerificacao() {
        let qtd_quantidade_retornada = 0;
        let produtos_entrega = [];
        let verifica = 0;
        let parar_operacao = false;
        let verifica_multiplo = false;
        let entrega_parcial = false; 
        let entrega_total = true;
        let verifica_multiplo_valor_fracao = 0;
        let verifica_multiplo_valor = 0;

              
        if (this.confirmar_retorno_total || this.confirmar_entrega_parcial) {
            
          for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
            
            if (this.manifesto_selecionado.entregas[i].entrega_id == this.entrega_id_selecionada) {
            
              for (let j = 0; j < this.manifesto_selecionado.entregas[i].itens.length; j++) {
                if(this.confirmar_entrega_parcial && !parar_operacao){
                
                  if(Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) > 0){
                    entrega_parcial = true;
                  }
                  
                  if(Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) != Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade)){
                    entrega_total = false;
                  }
                }
                
                if(!this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada){
                  this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada = 0;
                }
                
                if (Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) > Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade)){
                  Biblioteca.exclamar(
                    "A quantidade informada "+ 
                    Biblioteca.nPadrao(Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada), 3) +
                    " do produto "+
                    this.manifesto_selecionado.entregas[i].itens[j].produto_id +
                    " é maior que a quantidade total a ser entregue  " + 
                    this.manifesto_selecionado.entregas[i].itens[j].quantidade + 
                    "!"
                  );
                  parar_operacao = true;
                }
          
                qtd_quantidade_retornada += Number(Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada));
                
                /*pegando resto para verificar valor fracionado*/
                verifica += qtd_quantidade_retornada % 1;
              
                /* tranformando o calculo em retorno boleano true ou false*/
                if (Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade) < 1){
                  verifica_multiplo_valor_fracao = Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) / Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].multiplo_venda);
                  verifica_multiplo_valor_fracao  = verifica_multiplo_valor_fracao % 2;
                  verifica_multiplo = verifica_multiplo_valor_fracao != 0;
                }else{                  
                  verifica_multiplo_valor = (Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) / Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].multiplo_venda));
                  verifica_multiplo_valor  = verifica_multiplo_valor % 1;
                  verifica_multiplo = verifica_multiplo_valor != 0;
                }
              
                if (verifica_multiplo && !parar_operacao && Number(Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) > 0) && Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada) != Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade)){
                  Biblioteca.exclamar(
                    "A quantidade informada "+ 
                    Biblioteca.nPadrao(Biblioteca.valor(this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada), 3) +
                    " do produto "+
                    this.manifesto_selecionado.entregas[i].itens[j].produto_id +
                    " não se adequa ao seu múltiplo de venda  " + 
                    this.manifesto_selecionado.entregas[i].itens[j].multiplo_venda + 
                    "!"
                  );
                  
                  parar_operacao = true;
                }
                
                if(!this.confirmar_retorno_total){
                
                  if(this.manifesto_selecionado.entregas[i].itens[j].permite_venda_fracionada == "N" && verifica != 0 && !parar_operacao){
                  
                    Biblioteca.exclamar("O produto " + this.manifesto_selecionado.entregas[i].itens[j].produto_id + " não permite fracionamento! A quantidade será zerada!");
                    /*atribui zero no item que não permite fracionado*/
                    this.manifesto_selecionado.entregas[i].itens[j].quantidade_retornada = 0;
                    qtd_quantidade_retornada = 0;
                    parar_operacao = true;
                  }
                }
              
                produtos_entrega.push(this.manifesto_selecionado.entregas[i].itens[j])
              }
            }
          }
        }
      
        if(this.confirmar_entrega_parcial && entrega_total){
          Biblioteca.exclamar('Esta entrega foi definida como "Entrega Parcial" mas todos os itens foram marcados como retornados!');
          return;
        }
        
        if(this.confirmar_entrega_parcial && !entrega_parcial){
          Biblioteca.exclamar('Esta entrega foi definida como "Entrega Parcial" mas nenhum retorno foi informado!');
          return;
        }
        
        if(parar_operacao){
          return;
        }
        
        return {
          qtd_quantidade_retornada: Biblioteca.nPadrao(Biblioteca.valor(qtd_quantidade_retornada), 3),
          produtos_entrega: produtos_entrega
        }
      },
      
      modalTelefonesCadastro: function(telefones, cadastro_id, nome_cliente){
        if (telefones.length == 0) {

          this.controlSwalModalStatus = true;
          swal(
            "Atenção!",  "Não há telefones cadastrados"
            )
            .then(() => { }).finally(() => {
              this.controlSwalModalStatus = false;
            });

          return
        }

        this.cadastro_configurando.cadastro_id  = cadastro_id;
        this.cadastro_configurando.nome = nome_cliente;
        this.telefones_modal = telefones;
        this.abrirModalTelefonesCadastro = true;
      },

      getClasseUsuarioDisponivel: function(adicionado){
        if (adicionado)
          return 'w3-theme label-clicavel';
        else
          return 'w3-white label-clicavel';
      },

      formatarValor: function(valor, quant_casas_decimais = 3){
        var formatter = new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: quant_casas_decimais,
          maximumFractionDigits: quant_casas_decimais
        });

        return formatter.format(valor);
      },

      iniciarManifesto: function(){
        if (this.verificarMotoristaLogado())
          return;

        swal("Deseja iniciar o manifesto ?", {
          buttons: {
          nao: "Não",
          sim: "Sim",
          },
        })
        .then(async (opcao) => {
          switch (opcao) {
          case "sim":
            this.iniciar_manifesto = true;
            await this.atualizarManifesto();
            break;
          }
        });
      },

      checarEntrega(cadastro) {
        for (let i = 0; i < cadastro.entregas.length; i++) {
          if (!cadastro.entregas[i].entrega_parcial &&
            !cadastro.entregas[i].entrega_total &&
            !cadastro.entregas[i].retorno_total
          ){
            return false
          }
        }
        return true
      },

      async finalizarManifesto(){
        if (this.verificarMotoristaLogado()){
          return;
        }

        for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
          if (this.controlar_tempo_descarga){
            if (!this.manifesto_selecionado.entregas[i].chegada_informada){
              await swal(
                "É necessário informar o horário de chegada da entrega " + this.manifesto_selecionado.entregas[i].entrega_id + " " +
                "do cliente " + this.manifesto_selecionado.entregas[i].nome_cliente + ". " +
                "Deseja informar o horário de chegada agora?", 
                {
                  buttons: {
                    nao: "Não",
                    sim: "Sim" 
                  },
                }
              ).then(async (opcao) => {
                if (opcao == "sim") {
                  await this.modalIniciarEntrega(this.manifesto_selecionado.entregas[i]);
                }
              })
              return;
            }

            if 
              (
                !this.manifesto_selecionado.entregas[i].entrega_parcial &&
                !this.manifesto_selecionado.entregas[i].entrega_total &&
                !this.manifesto_selecionado.entregas[i].retorno_total
              )
            {
              await swal(
                "É necessário confirmar a entrega " + this.manifesto_selecionado.entregas[i].entrega_id + ". " +
                "Deseja confirmar a entrega agora?",
                {
                  buttons: {
                    nao: "Não",
                    sim: "Sim"
                  },
                }
              )
              .then(async (opcao) => {
                if (opcao == 'sim') {
                  await this.mostrarModalConfigurarEntrega(this.manifesto_selecionado.entregas[i]);
                }
              });
              return;
            }
            
            if (!this.manifesto_selecionado.entregas[i].saida_informada){
              await swal(
                "É necessário informar o horário de saida da entrega " + this.manifesto_selecionado.entregas[i].entrega_id + ' ' +
                "do cliente " + this.manifesto_selecionado.entregas[i].nome_cliente + '. ' +
                "Deseja informar o horário de saída agora?", 
                {
                  buttons: { 
                    nao: "Não",
                    sim: "Sim"
                  },
                }
              ).then(async (opcao) => {
                if (opcao == "sim") {
                  await this.modalFinalizarEntrega(this.manifesto_selecionado.entregas[i]);
                }
              });
              return;
            }
          }

          if
          (
            !this.manifesto_selecionado.entregas[i].entrega_parcial &&
            !this.manifesto_selecionado.entregas[i].entrega_total &&
            !this.manifesto_selecionado.entregas[i].retorno_total
          )
          {
            await swal(
              "É necessário confirmar a entrega " + this.manifesto_selecionado.entregas[i].entrega_id + ". " +
              "Deseja confirmar a entrega agora?", 
              {
                buttons: { 
                  nao: "Não",
                  sim: "Sim"
                },
              }
            ).then(async (opcao) => {
              if (opcao == "sim") {
                await this.mostrarModalConfigurarEntrega(this.manifesto_selecionado.entregas[i]);
              }
            })
            return;
          }
        }

        this.controlSwalModalStatus = true;
        await swal("Deseja finalizar o manifesto?", {
          buttons: {
          nao: "Não",
          sim: "Sim",
          },
        })
        .then(async (opcao) => {
          switch (opcao) {
            case "sim":
              try {
                this.finalizar_manifesto = true;
                let retorno_verificacao = await this.buscarProdutosEntregaVerificacao()

                let parametros = {
                  manifesto_id: this.manifesto_selecionado.manifesto_id,
                  cliente_id: this.cliente_id_entrega,
                  entrega_id_selecionada: this.entrega_id_selecionada,
                  iniciar_manifesto: this.iniciar_manifesto ? 'S': 'N',
                  finalizar_manifesto: this.finalizar_manifesto ? 'S': 'N',
                  informar_chegada: this.informar_chegada ? 'S': 'N',
                  informar_saida: this.informar_saida ? 'S': 'N',
                  data_chegada: this.data_chegada,
                  hora_chegada: this.hora_chegada,
                  data_saida: this.data_saida,
                  hora_saida: this.hora_saida,
                  confirmar_entrega_total: this.confirmar_entrega_total ? 'S': 'N',
                  confirmar_entrega_parcial: this.confirmar_entrega_parcial ? 'S': 'N',
                  confirmar_retorno_total: this.confirmar_retorno_total ? 'S': 'N',
                  produtos_entrega: retorno_verificacao.produtos_entrega,
                  grupo_endereco_id: this.grupo_endereco_id_selecionado,
                  motivo_retorno: this.motivo_retorno,
                  observacao_retorno: this.observacao_retorno,
                  observacao_nota: this.observacao_nota,
                  nome_pessoa_recebeu_web: this.nome_pessoa_recebeu_web.toUpperCase(),
                  assinatura_digital: this.assinatura_definida != null ? this.assinatura_definida.replace(/^data:image\/[a-z]+;base64,/, ""): ''
                }

                let retorno = await RManifesto.atualizarManifesto(this.axios, parametros);

                if (retorno.houve_erro != 'N'){
                  throw new Error(retorno.mensagem);
                }

                this.abrirModalConfigurarEntrega = false;
                await this.enviarFotosManifesto(retorno.dados);
              } catch (e) {                
                this.processando_fotos = false;
                Biblioteca.exclamar(e.message);
              }
        
              break;
          }
        }).finally(() => {
          this.controlSwalModalStatus = false;
        });
      },

      iniciarEntrega: function(){
        if (this.data_chegada == ''){
          Biblioteca.exclamar("É necessário inserir a data de chegada!");
          return;
        }

        if (this.hora_chegada == ''){
          Biblioteca.exclamar("É necessário inserir a hora de chegada!");
          return;
        }

        this.informar_chegada = true;
        this.atualizarManifesto();
        this.abrirModalInformarHoraChegada = false
      },

      async finalizarEntrega(){
        if (this.data_saida == ''){
          Biblioteca.exclamar("É necessário inserir a data de saida!");
          return;
        }

        if (this.hora_saida == ''){
          Biblioteca.exclamar("É necessário inserir a hora de saida!");
          return;
        }

        this.informar_saida = true;
        await this.atualizarManifesto();
        this.abrirModalInformarHoraSaida = false;
      },

      async atualizarManifesto() {
        try {

          let retorno_verificacao = await this.buscarProdutosEntregaVerificacao();

          let parametros = {
            manifesto_id: this.manifesto_selecionado.manifesto_id,
            cliente_id: this.cliente_id_entrega,
            entrega_id_selecionada: this.entrega_id_selecionada,
            iniciar_manifesto: this.iniciar_manifesto ? 'S': 'N',
            finalizar_manifesto: this.finalizar_manifesto ? 'S': 'N',
            informar_chegada: this.informar_chegada ? 'S': 'N',
            informar_saida: this.informar_saida ? 'S': 'N',
            data_chegada: this.data_chegada,
            hora_chegada: this.hora_chegada,
            data_saida: this.data_saida,
            hora_saida: this.hora_saida,
            confirmar_entrega_total: this.confirmar_entrega_total ? 'S': 'N',
            confirmar_entrega_parcial: this.confirmar_entrega_parcial ? 'S': 'N',
            confirmar_retorno_total: this.confirmar_retorno_total ? 'S': 'N',
            produtos_entrega: retorno_verificacao.produtos_entrega,
            grupo_endereco_id: this.grupo_endereco_id_selecionado,
            motivo_retorno: this.motivo_retorno,
            observacao_retorno: this.observacao_retorno,
            observacao_nota: this.observacao_nota,
            nome_pessoa_recebeu_web: this.nome_pessoa_recebeu_web.toUpperCase(),
            assinatura_digital: this.assinatura_definida != null ? this.assinatura_definida.replace(/^data:image\/[a-z]+;base64,/, ""): ''
          }

          let retorno = await RManifesto.atualizarManifesto(this.axios, parametros);
          
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          this.abrirModalConfigurarEntrega = false;
          await this.enviarFotosManifesto(retorno.dados);
          this.mostrarModalAssinatura = false;
        } catch (e) {
          this.processando_fotos = false;
          Biblioteca.exclamar(e.message);
        }
      },

      async atualizarProcessoManifesto(data){
        // Iniciou manifesto
        if(data.processo == 'I') {
          this.manifesto_iniciado = true;
          this.iniciar_manifesto = false;
          this.controlSwalModalStatus = true;

          await swal({
            title: "Iniciou manifesto!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          })
          .then(() => {}).finally(() => {
            this.controlSwalModalStatus = false;
          });
        }

        // Finalizou manifesto
        if(data.processo == 'D') {
          this.manifesto_finalizado = true;
          this.finalizar_manifesto = false;
          this.controlSwalModalStatus = true;
          await swal({
            title: "Finalizou manifesto!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          })
          .then(() => {}).finally(() => {
            this.iniciarPagina();
            this.controlSwalModalStatus = false;
          });
        }

        // Informou chegada
        if(data.processo == 'C') {
          for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
            if
              (
                (this.manifesto_selecionado.entregas[i].cadastro_id == this.cliente_id_entrega) &&
                (this.manifesto_selecionado.entregas[i].grupo_endereco_id == this.grupo_endereco_id_selecionado)
              )
            {
              this.manifesto_selecionado.entregas[i].chegada_informada = true;
            }
          }

          this.informar_chegada = false;
          this.entrega_id_selecionada = 0;
          this.grupo_endereco_id_selecionado = 0;
          this.hora_chegada = '';

          this.controlSwalModalStatus = true;
          await swal({
            title: "Informou chegada!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          }).then(() => {}).finally(() => {
            this.controlSwalModalStatus = false;
          });

          await this.buscarManifestoCompleto(this.manifesto_selecionado);
        }

        // Informou saida
        if(data.processo == 'S') {
          for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
            if
              (
                (this.manifesto_selecionado.entregas[i].cadastro_id == this.cliente_id_entrega) &&
                (this.manifesto_selecionado.entregas[i].grupo_endereco_id == this.grupo_endereco_id_selecionado)
              )
            {
              this.manifesto_selecionado.entregas[i].saida_informada = true;
            }
          }

          this.informar_saida = false;
          this.entrega_id_selecionada = 0;
          this.grupo_endereco_id_selecionado = 0;
          this.hora_saida = '';
          this.data_chegada = '';

          this.controlSwalModalStatus = true;
          this.abrirModalInformarHoraSaida = false;

          await swal({
            title: "Informou saida!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          }).then(() => {}).finally(async () => {
            this.controlSwalModalStatus = false;
            await this.buscarManifestoCompleto(this.manifesto_selecionado);
            await this.finalizarManifesto();
          });
        }

        // Informou entrega total
        if(data.processo == 'T') {
          for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
            if
              (
                (this.manifesto_selecionado.entregas[i].cadastro_id == this.cliente_id_entrega) &&
                (this.manifesto_selecionado.entregas[i].grupo_endereco_id == this.grupo_endereco_id_selecionado)
              )
            {
              this.manifesto_selecionado.entregas[i].entrega_total = true;
            }
          }

          await swal({
            title: "Informou entrega total!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          });

          this.abrirModalConfigurarEntrega = false;

          this.confirmar_entrega_total = false;
          this.entrega_id_selecionada = 0;
          this.grupo_endereco_id_selecionado = 0;
          this.assinatura_definida = null;
          this.fotos = [
            {base64: undefined},
            {base64: undefined},
            {base64: undefined}
          ];
          
          await this.buscarManifestoCompleto(this.manifesto_selecionado);
        }

        // Informou entrega parcial
        if(data.processo == 'P') {
          for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
            if
              (
                (this.manifesto_selecionado.entregas[i].cadastro_id == this.cliente_id_entrega) &&
                (this.manifesto_selecionado.entregas[i].grupo_endereco_id == this.grupo_endereco_id_selecionado)
              )
            {
              this.manifesto_selecionado.entregas[i].entrega_parcial = true;
            }
          }

          await swal({
            title: "Informou entrega parcial!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          });

          this.confirmar_entrega_parcial = false;
          this.entrega_id_selecionada = 0;
          this.grupo_endereco_id_selecionado = 0;
          this.assinatura_definida = null;
          this.fotos = [
            {base64: undefined},
            {base64: undefined},
            {base64: undefined}
          ];

          await this.buscarManifestoCompleto(this.manifesto_selecionado);
        }

        // Informou retorno total
        if(data.processo == 'R') {
          for (let i = 0; i < this.manifesto_selecionado.entregas.length; i++) {
            if (this.manifesto_selecionado.entregas[i].entrega_id == this.entrega_id_selecionada)
              this.manifesto_selecionado.entregas[i].retorno_total = true;
          }

          await swal({
            title: "Informou retorno total!",
            text: data.msg,
            icon: "success",
            button: "Ok",
          });

          this.confirmar_retorno_total = false;
          this.entrega_id_selecionada = 0;
          this.grupo_endereco_id_selecionado = 0;

          await this.buscarManifestoCompleto(this.manifesto_selecionado);
        }
      },

      voltarPaginaPrincipal(){
        this.manifesto_iniciado = false;
        this.manifesto_selecionado.manifesto_id = undefined;
        this.buscarManifestos();
      },

      habilitarVoltarPaginaPrincipal(){
        let retorno =
          (
            !this.controlSwalModalStatus && 
            !this.abrirModalInformarHoraChegada &&
            !this.abrirModalInformarHoraChegada && 
            !this.abrirModalInformarHoraSaida && 
            !this.abrirModalAbrirMapaEntrega && 
            !this.abrirModalConfigurarEntrega && 
            !this.abrirModalTelefonesCadastro
          );

        return retorno;
      },

      habilitarBuscarManifestos(){
        if (!this.manifesto_selecionado){
          return true;
        }

        if (!this.manifesto_selecionado.manifesto_id){
          return true;
        }

        return false;
      },

      async buscarManifestos() {
        try {
          this.processando = true;
          this.manifestos_disponiveis_filtrados = {};

          let parametros = {
            operacao: 'buscarManifestosAberto',            
            mostrar_todos_manifestos_aberto: this.mostrar_todos_manifestos_aberto ? 'S' : 'N'
          }
        
          let retorno = await RManifesto.buscarManifesto(this.axios, parametros);

          this.processando = false;
          this.confirmar_retorno_total = false;
          this.confirmar_entrega_total = false;
          this.confirmar_entrega_parcial = false;

          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }
          
          this.manifestos_disponiveis_filtrados = Object.assign([], retorno.dados.manifesto);
        
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      async buscarManifestoCompleto(manifesto) {
        try {

          if (!manifesto.manifesto_id){
            return;
          }

          this.manifesto_selecionado = {};
          this.processando = true;

          let parametros = {
            manifesto_id: manifesto.manifesto_id,
            operacao: 'buscarManifestoCompleto'
          }
          
          let retorno = await RManifesto.buscarManifestoCompleto(this.axios, parametros);
         
          this.processando = false;
          
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }
          
          this.processando = false;
          this.atualizarManifestoSelecionado(retorno.dados);
        } catch (e) {
          this.processando = false;
          Biblioteca.exclamar(e.message);
        }
      },

      atualizarManifestoSelecionado: function(data){
        this.manifesto_iniciado = data.status == 'I';
        this.controlar_tempo_descarga = data.controlar_tempo_descarga == 'S';
        this.motorista_logado_manifesto = (data.motorista_id == this.cadastro_id_logado);

        for (let i = 0; i < data.entregas.length; i++) {
          data.entregas[i].visualizar = false;

          if (data.entregas[i].tipo_imovel_entrega == 'NIN')
            data.entregas[i].tipo_imovel_entrega = 'Não informado';

          if (data.entregas[i].ponto_referencia_entrega == undefined)
            data.entregas[i].ponto_referencia_entrega = 'Não informado';

          data.entregas[i].chegada_informada = data.entregas[i].data_hora_chegada != '30/12/1899';
          data.entregas[i].saida_informada = data.entregas[i].data_hora_saida != '30/12/1899';
          data.entregas[i].entrega_total = data.entregas[i].status == 'T';
          data.entregas[i].entrega_parcial = data.entregas[i].status == 'P';
          data.entregas[i].retorno_total = data.entregas[i].status == 'R';
        }

        this.manifesto_selecionado = Object.assign({}, data);
      },

      async mostrarModalConfigurarEntrega(entrega){
        let retorno = await this.verificarEntregaConfirmada(entrega.entrega_id);

        if (!retorno){
          entrega.entrega_total = true;
          this.confirmar_retorno_total = false;
          this.confirmar_entrega_total = false;
          this.confirmar_entrega_parcial = false;
          this.$forceUpdate();
          return;
        }

        entrega.tipo_entrega = '';
        entrega.motivo_retorno = '';
        entrega.observacao_retorno = '';
        entrega.observacao_nota = '';
        entrega.nome_pessoa_recebeu = '';
        entrega.ciente_recebimento_entrega = false;
		    this.assinatura_definida = undefined;        this.entrega_configurando = Object.assign({}, entrega);
        this.abrirModalConfigurarEntrega = true;
        this.abrirContentConfigurarEntrega = false;
        this.confirmar_retorno_total = false;
        this.confirmar_entrega_total = false;
        this.confirmar_entrega_parcial = false;
      },

      async buscarUsuarioLogado(){
        if (!RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }
      
        let dados_usuario_logado = await JSON.parse(JSON.stringify(store.state.usuario_logado));
        let parametros_gerais = await JSON.parse(JSON.stringify(store.state.parametros_gerais));
        
        this.carregando_motorista_inicial = true;
        this.indice_motorista_pesquisa = 5;
        this.chave_motorista_pesquisa = dados_usuario_logado.cadastro_id;
        this.cadastro_id_logado = dados_usuario_logado.cadastro_id;
        this.tipo_autenticacao = dados_usuario_logado.tipo_autenticacao;
        this.logado_usuario_santri = (
          (
            (dados_usuario_logado.tipo_autenticacao == 'UAD') &&
            (parametros_gerais.usuario_santri_id == dados_usuario_logado.funcionario_id)
          ) ? 
          'S' : 
          'N'
        );
      },

      verificarMotoristaLogado: function(){
        if (!this.motorista_logado_manifesto){
          swal({
            title: "Permissão negada",
            text: "Apenas o motorista designado para a entrega no manifesto possui permissão para realizar esse processo!",
            icon: "error",
            button: "Ok",
          });

          return true;
        }
      },

      async configurarEntregaTotal(entrega){
        if (this.verificarMotoristaLogado())
          return;

        await swal("Deseja confirmar esta entrega como Entrega Total?", {
          buttons: {
            nao: "Não",
            sim: "Sim",
          },
        })
        .then(async (opcao) => {
          switch (opcao) {
            case "sim":
              entrega.entrega_parcial = false;
              entrega.retorno_total = false;
              entrega.visualizar = false;
              this.cliente_id_entrega = entrega.cadastro_id;
              this.entrega_id_selecionada = entrega.entrega_id;
              this.grupo_endereco_id_selecionado = entrega.grupo_endereco_id;
              this.confirmar_entrega_total = true;
              await this.atualizarManifesto();
              break;
          }
        });
      },

      async buscarMotivosRetornos(){
        try {
          let retorno = await RManifesto.buscarMotivosRetorno(this.axios);
          
          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }          

          this.motivos_retornos = retorno.dados.motivos_retorno;
        } catch (e) {
          Biblioteca.exclamar(e.message);         
        }
      },

      entregaConfigurada: function(entrega) {
        return entrega.entrega_parcial || entrega.entrega_total || entrega.retorno_total;
      },

      formatarValor: function(valor, quant_casas_decimais = 2){
        return formatarValorGeral(valor, quant_casas_decimais);
      },

      getClasseEntrega: function(entregue){
        return "card-item";
      },

      limparManifestoSelecionado(event){
        event.preventDefault()
        this.manifesto_selecionado = {};
        this.buscarManifestos();
      },

      existeRecebimentoEntrega(entrega){
        return entrega.pedido.filter(function(pedido){
          return pedido.recebimento_entrega == 'S';
        }).length > 0;
      },
      
      adicionarFoto: function(imgClicada) {
        this.imagemSelecionada = imgClicada;
        document.getElementById('ifotos').click();
      },

      lerArquivo(){
        let input = document.getElementById('ifotos');

        if (!input) {
          return;
        }

        if (!input.files) {
          return;
        }

        var carregarImagem = new FileReader();
        var nomeImagem = '#img0' + this.imagemSelecionada;
        var processando = true;
        
        carregarImagem.readAsDataURL(input.files[0]);
        carregarImagem.onload = (arquivo) => {
          $(nomeImagem).attr('src', arquivo.target.result);
        }
      },

      async limparFoto(indice) {
        this.fotos[indice].base64 = undefined;
        document.getElementById('img0' + (indice + 1)).src = await this.fotoPadrao
      },

      iniciarPagina(){
        Object.assign(this.$data, this.$options.data.call(this));
      
        this.indice_motorista_pesquisa = 1;
        this.entrega_id_selecionada = 0;
        this.grupo_endereco_id_selecionado = 0;
        this.tipo_pesquisa_mapa = 'CEP';
        this.buscarUsuarioLogado();
        this.buscarMotivosRetornos();        
        this.buscarManifestos();
      },

      async enviarFotosManifesto(data){
        try {
          
          this.processando_fotos = true;
          let imagens = document.getElementsByTagName("img");

          for (let i = 0; i < imagens.length; i++){
            if (imagens[i].id == 'img_assinatura'){
              continue;
            }

            if (imagens[i].src.indexOf(this.fotoPadrao) != -1){
              continue;
            }

            // Compactando fotos
            let mime_type = "image/jpeg";
            let maxWidth = 1000;
          
            let natW = imagens[i].naturalWidth;
            let natH = imagens[i].naturalHeight;
            let ratio = natH / natW;

            if (natW > maxWidth) {
              natW = maxWidth;
              natH = ratio * maxWidth;
            }

            let cvs = document.createElement('canvas');
            cvs.width = natW;
            cvs.height = natH;

            let ctx = cvs.getContext("2d").drawImage(imagens[i], 0, 0, natW, natH);
            // Compactando fotos para 60% de qualidade
            let newImageData = cvs.toDataURL(mime_type, 60 / 100);

            let result_image_obj = new Image();
            result_image_obj.src = newImageData;

            let base64 = result_image_obj.src
            base64 = base64.replace(/^data:image\/[a-z]+;base64,/, "")

            if (imagens[i].id == 'img01'){
              this.fotos[0].base64 = base64;
            }
            else if (imagens[i].id == 'img02'){
              this.fotos[1].base64 = base64;
            }
            else if (imagens[i].id == 'img03'){
              this.fotos[2].base64 = base64;
            }
          }

          // Descobrindo a quantidade de fotos a ser enviada para o servidor
          let qtd_fotos_enviadas = 0;
          let foto_envio_atual = 0;

          for (let i = 0; i < this.fotos.length; i++){
            if (this.fotos[i].base64 == undefined){
              continue;
            }
              
            qtd_fotos_enviadas++; 
          }

          // Enviando fotos para o servidor
          for (let i = 0; i < this.fotos.length; i++){
            if (this.fotos[i].base64 == undefined){
              continue;
            }

            foto_envio_atual++;
            this.descricao_processando_fotos = 'Enviando fotos ' + foto_envio_atual + '/' + qtd_fotos_enviadas + '..';

            try {

              let parametros = {
                entrega_id: this.entrega_id_selecionada,
                foto_base64: this.fotos[i].base64,
                manifesto_id: this.manifesto_selecionado.manifesto_id
              }

              let retorno = await RFotoEntrega.gravarFotosManifesto(this.axios, parametros);

              if (retorno.houve_erro != 'N'){
                throw new Error(retorno.mensagem);
              }
            } catch (e) {
              Biblioteca.exclamar('Não foi possível enviar todas as fotos, motivo: ' + e.message);
            }
          }

          this.processando_fotos = false;
          // Atualizando os dados do manifesto
          await this.atualizarProcessoManifesto(data);
        } catch (e) {
          this.processando_fotos = false;
          Biblioteca.exclamar(e.message);
        }
      },

      async verificarEntregaConfirmada(entrega_id){
        let retornoVerificacao = false;

        try {
          let parametros = {
            entrega_id: entrega_id,
          }

          let retorno = await RManifesto.verificarEntregaConfirmada(this.axios, parametros);

          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          if (retorno.dados.entrega_confirmada == 'S'){
            retornoVerificacao = false;
            await swal(retorno.dados.mensagem);
          } else {
            retornoVerificacao = true;
          }
        } catch (e) {
          Biblioteca.exclamar('Não foi verificar se a entrega está confirmada, motivo: ' + e.message);
        }

        return retornoVerificacao;
      },

      async voltarStatusManifesto(manifesto_id){      
        await swal("Ao voltar o status do manifesto para 'aberto' todas as informações de entregas, fotos, assinaturas serão perdidas. Deseja continuar?", {
          buttons: {
            nao: "Não",
            sim: "Sim"
          },
        })
        .then(async (opcao) => {          
          if (opcao == 'nao') {
            return;
          }

          try {

            let parametros = {
              manifesto_id: manifesto_id,
              operacao: 'voltarStatusManifesto'
            }

            let retorno = await RManifesto.buscarManifesto(this.axios, parametros);
            
            if (retorno.houve_erro != 'N'){
              throw new Error(retorno.mensagem);
            }

            swal({
              title: "Operação realizada com sucesso.",
              icon: "success",
              button: {
                confirm: {
                  text: "OK",
                  value: true,
                  visible: true,
                  closeModal: true,
                },
              },
            })
            .then((value) => {              
              this.buscarManifestos();
            });
          } catch (e) {
            this.processando = false;
            Biblioteca.exclamar(e.message);
          }
        });
      }    
    },    
    created: function () {
      window.addEventListener('beforeunload', function(evt) {
        var message = 'Deseja realmente sair da página?';

        if (typeof evt == 'undefined') {
          evt = window.event;
        }
        if (evt) {          
          evt.returnValue = message;
        }

        return message;
      });

      this.iniciarPagina();
    },
  }
</script>

<style scoped>
  .wrapper {
    position: relative;
    width: 350px;
    height: 200px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .signature-pad {
    position: absolute;
    left: 0;
    top: 0;
    width:350px;
    height:200px;
  }

  .container_entrega {
    border-left: 3px solid #9c1d1c;
    /* border-radius: 5px; */
    padding: 7px;
    margin: 0 0 16px 0
  }

  .tamanho-minimo-200 {
    min-width: 200px
  }

  .tamanho-140{
    width: 140px
  }

  .tamanho-43{
    width: 43.25px;
  }

  .input-quantidade-retornada{
    width: 100%;
    min-width: 150px;
  }

  .fotos {
    display: none;
  }

  .imagem{
    max-width: 100%;
    border-radius: 10px;
    border: 1px solid #999999;
    overflow:hidden;
  }

  .assinatura{
    width: 100%;
    height: 150px;
    border-radius: 10px;
    border: 1px solid #999999;
    overflow:hidden;
  }

  .foto- > span{
    background-color: #ffffff;
    border: 1px solid #bbbbbb;
  }
  cabecalho
  .foto-cabecalho > span:hover, .foto-cabecalho > span{
    border-radius: 25px;
    right: 10px;
    top: 10px;
    background-color: white!important;
    color: black;

  }

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }

  .card-item:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

  .line-item {
    border-bottom: 1px solid #000;
  }

  .border-list-product {
    border-bottom: 1px solid #8d1007;
    padding-bottom: 10px;
     margin: 10px 0;
  }

  .text-card {
    margin: 0;
    padding:0;
    font-size: 12px;
    font-weight: bold;
  }

  .align-button-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media only screen and (max-width: 600px) {
    .no-margin-mobile {
      margin: 0px !important;
    }

    .no-padding-mobile {
      margin: 0px !important;
    }
  }

   .botao-tipo-entrega {
    padding: 5px 0 5px 0;
    width: 98%;
    border-radius: 20px;
    outline: 0;
    background-image: linear-gradient(to right, #dddddd, #cccccc);
    color: #000000;
    border: 1px solid #aaaaaa;
    cursor: pointer;
  }

  .botao-tipo-entrega-selecionado {
    background-image: linear-gradient(to right, #9c1d1c, #691212);
    color: #ffffff;
    border: 1px solid #cccccc;
  }

  #floating-button {
    z-index: 5 !important;
    padding-left: 14px!important; 
    padding-top: 7px!important; 
    font-size: 19px; 
    border-radius: 30px; 
    width:55px; 
    height:55px; 
    border: 4px solid #f7f7f7!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  #floating-button:hover {
    color: #9c1d1c!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Manifestos.vue